import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import StatusBadge from './StatusBadge';

const headerCellStyles = {
  color: '#64748B',
  fontWeight: 700,
  fontSize: '0.75rem',
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  py: 2,
};

const CustomTable = ({ heading, rows, pageData, navigateToEdit, idKey }) => {
  const handleClick = id => {
    navigateToEdit(id);
  };
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: '16px',
        border: '1px solid #E2E8F0',
        backgroundColor: '#FFFFFF',
        overflowX: 'auto',
      }}
    >
      <Table sx={{ minWidth: 800 }}>
        <TableHead>
          <TableRow sx={{ borderBottom: '1px solid #E2E8F0' }}>
            {heading.map((item, index) => (
              <TableCell sx={headerCellStyles} key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '&:hover': { backgroundColor: '#F8FAFC' },
                transition: 'background-color 0.2s ease',
                cursor: 'pointer',
              }}
              onClick={() => handleClick(row[idKey])}
            >
              <TableCell
                key={`SI-${index}`}
                sx={{
                  color: '#94A3B8',
                  fontWeight: 700,
                  width: '70px',
                }}
              >
                {((pageData.current.pageNumber - 1) * 10) + (index + 1)}
              </TableCell>

              {Object.keys(row).map((key, i) => (
                (
                  (!key.endsWith('id')) && key !== 'status' &&
                  <TableCell
                    key={i}
                    sx={{
                      color: '#0F172A',
                      fontSize: '0.875rem',
                    }}
                  >
                    {row[key]}
                  </TableCell>
                )
              ))}

              <TableCell>
                <StatusBadge status={row.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

CustomTable.propTypes = {
  heading: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  pageData: PropTypes.object.isRequired,
  navigateToEdit: PropTypes.func.isRequired,
  idKey: PropTypes.string.isRequired,
};

export default CustomTable;